<script>
export default {
  name: "RecruitLink",
  data(){
    return {
      links: [
        { sorts: '01', title: '研究開発', descriptions: ['自動車業界から化学メーカーへ。', 'ノウハウをクレハで遺憾無く発揮。'] , tags: '#CAE解析 #PGA樹脂 #後輩育成', image: require('@/assets/img/career/01.jpg'), to: '/midcareer/staff01' },
        // { sorts: '02', title: '情報システム', descriptions: ['システム刷新プロジェクトへの挑戦。', '正解のない中で最適解を導き出す。'] , tags: '#ネットワークエンジニア\n#システム導入 #正解がない仕事', image: require('@/assets/img/career/02.jpg'), to: '/midcareer/staff02' },
        { sorts: '02', title: '法務', descriptions: ['法律の専門性を磨きながら、', '事業の基盤を作り上げていく。'] , tags: '#社会への貢献 #企業法務 \n#他部署との協働', image: require('@/assets/img/career/03.jpg'), to: '/midcareer/staff02' },
        { sorts: '03', title: '設備保全', descriptions: ['電気設備の施工経験を活かして、', '事業所のスマート保全化に挑む。'] , tags: '#電気設備 #生産環境の質向上 \n#スマート保全化', image: require('@/assets/img/career/04.jpg'), to: '/midcareer/staff03' },
      ]
    }
  }
}
</script>

<template>
  <div class="footer-link">
    <div class="footer-link-inner">
      <h4>社員紹介</h4>
      <div class="links">
        <router-link v-for="(item, index) in links" :key="index" :to="item.to">
          <span class="sort">{{item.sorts}}</span>
          <div>
            <picture>
              <source :srcset="item.image"
                      media="(min-width: 901px)">
              <source :srcset="item.image"
                      media="(max-width: 900px)">
              <img :src="item.image" alt="" />
            </picture>
          </div>
          <div>
            <span class="title">{{item.title}}</span>
            <p class="description" v-for="(des, indexDes) in item.descriptions" :key="indexDes">{{des}}</p>
            <span class="tags">{{item.tags}}</span>
          </div>
          <span class="tags">{{item.tags}}</span>
        </router-link>
      </div>
      <div class="action">
        <router-link to="/career/info/">
          採用情報はこちら
          <img src="@/assets/img/career/icon-arrow-right.svg" alt="採用情報はこちら" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.footer-link{
  background: rgb(255,255,255);
  background: linear-gradient(180deg, rgba(255,255,255,0.4976584383753502) 0%, rgba(62,165,197,0.05) 0%);
}
.footer-link-inner{
  transition: all ease-in-out 0.3s;
  max-width: 930px;
  margin: 0 auto;
  padding: 96px 0 150px 0;
  overflow: hidden;
  @media print, screen and (max-width: 900px) {
    max-width: 480px;
    padding: 75px 0 95px 0;
    width: 90%;
    margin: 0 auto;
  }
  & > .links {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 54px;
    row-gap: 96px;
    @media print, screen and (max-width: 900px) {
      grid-template-columns: 100%;
      row-gap: 64px;
    }
  }

  & > h4{
    font-size: 30px;
    margin: 0 0 86px 0;
    text-align: center;
    @media print, screen and (max-width: 900px) {
      font-size: 20px;
      margin: 0 0 64px 0;
    }
  }
}

.links{
  & > a{
    position: relative;
    & > .sort{
      color: var(--darkBlue);
      font-weight: 500;
      font-size: 64px;
      letter-spacing: 5px;
      font-family: 'Montserrat', sans-serif;
      position: absolute;
      top: -20%;
      left: 0;
      @media print, screen and (max-width: 900px) {
        top: -16%;
        line-height: normal;
        font-size: 40px;
      }
    }

    & > div{
      &:nth-child(2){
        width: 100%;
        height: 270px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        & > picture{
          width: 90%;
          border-radius: 12px;
          overflow: hidden;
          height: 100%;
          & > img{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        @media print, screen and (max-width: 900px) {
          justify-content: flex-start;
          height: 134px;

          & > picture{
            width: 43.5%;
          }
        }
      }

      &:nth-child(3){
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        position: absolute;
        bottom: 11%;

        @media print, screen and (max-width: 900px) {
          top: 0;
          left:calc(43.5% + 18px);
          row-gap: 12px
        }
      }
    }

    & > div{
      & > .title{
        background-color: var(--darkBlue);
        max-width:125px ;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        color: white;
        font-weight: 700;
      }

      & > .description{
        background-color: white;
        width: fit-content;
        font-size: 20px;
        font-weight: 700;
        color: black;
        margin: 0;
        padding: 0 8px;
        white-space: nowrap;
        transition: all ease-in-out .3s;
      }

      & > .tags{
        display: none;
      }

      @media print, screen and (max-width: 900px) {
        & > title{
          font-size: 14px;
        }

        & > .description{
          font-size: 14px;
          margin-left: -15%;
        }

        & > .tags{
          display: block;
          font-size: 12px;
          margin: 0;
          color: var(--darkBlue);
          white-space: pre-wrap;
          line-height: normal;
        }
      }


      @media print, screen and (max-width: 414px) {
        & > .tags{
          white-space: pre-line;
        }
        & > .description{
          margin-left: -12%;
          font-size: 12px;
        }
      }
    }


    & > .tags{
      display: block;
      margin-top: 28px;
      font-weight: 500;
      font-size: 14px;
      color: var(--darkBlue);
      @media print, screen and (max-width: 900px) {
        display: none;
      }
    }

  }
}

.action{
  & > a{
    @media print, screen and (max-width: 900px) {
      column-gap: 28px;
      height: 68px;
      max-width: 80%;
      font-size: 20px;
      margin-top: 100px;
      & > img {
        width: 62px;
        object-fit: cover;
      }
    }
    @media print, screen and (max-width: 414px) {
      max-width: 100%;
    }
    background: var(--darkBlue);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 98px;
    width: 100%;
    max-width: 550px;
    column-gap: 30px;
    font-size: 25px;
    font-weight: 700;
    color: white;
    border-radius: 100px;
    margin: 105px auto 0 auto;
    transition: all ease-in-out 0.3s;
    & > img{
      transition: all ease-in-out 0.3s;
      margin-bottom: -12px;
    }
  }
}
</style>
